import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

export default class extends Controller {
  static targets = ["badge", "dropdown", "list"]

  connect() {
    this.subscribeToNotifications()
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  subscribeToNotifications() {
    const consumer = createConsumer()
    this.subscription = consumer.subscriptions.create("AdminNotificationsChannel", {
      received: (data) => {
        this.handleNewNotification(data)
      }
    })
  }

  handleNewNotification(data) {
    // Update badge count
    const currentCount = parseInt(this.badgeTarget.dataset.count) || 0
    const newCount = currentCount + 1
    this.badgeTarget.dataset.count = newCount
    this.badgeTarget.textContent = newCount

    // Add pulse animation
    this.badgeTarget.classList.add("animate-pulse")
    setTimeout(() => {
      this.badgeTarget.classList.remove("animate-pulse")
    }, 2000)

    // Add notification to list
    this.prependNotification(data)
  }

  prependNotification(data) {
    const notificationHTML = `
      <a href="${data.url}"
         data-turbo-method="patch"
         class="block p-4 hover:bg-gray-50 transition-colors border-b border-gray-100 ${data.bg_color_class}"
         data-notification-id="${data.id}">
        <div class="flex items-start gap-3">
          <div class="flex-shrink-0 mt-1">
            ${this.getIconSVG(data.icon)}
          </div>
          <div class="flex-1">
            <p class="font-semibold text-sm text-gray-900">${data.title}</p>
            <p class="text-sm text-gray-600 mt-1">${data.message}</p>
            <p class="text-xs text-gray-400 mt-1">${data.created_at}</p>
          </div>
        </div>
      </a>
    `

    if (this.hasListTarget) {
      const firstChild = this.listTarget.firstElementChild
      if (firstChild && firstChild.classList.contains("p-8")) {
        // Replace empty state
        this.listTarget.innerHTML = notificationHTML
      } else {
        // Prepend to existing notifications
        this.listTarget.insertAdjacentHTML("afterbegin", notificationHTML)
      }
    }
  }

  getIconSVG(icon) {
    const icons = {
      calendar: '<svg class="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>',
      envelope: '<svg class="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>',
      user: '<svg class="w-5 h-5 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path></svg>',
      bell: '<svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path></svg>'
    }
    return icons[icon] || icons.bell
  }
}
